import React from 'react'
import AOS from 'aos';
import "aos/dist/aos"

// components
import NavBar from "./header"

const Banner = ( { bannerClass, children } ) => {
    AOS.init( {
        duration: 2000
    } );
    return (
        <div className={`top-content ${bannerClass}`}>
            <NavBar />
            <div className="banner">
                <div className="container">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Banner
